import { DEFAULT_META, PRODUCT_META_OVERRIDES, getStaticMeta } from "./seoShared";

export const defaultMeta = DEFAULT_META;

/** Static-route meta shared with the prerender (see seoShared.js). */
export function getPageMeta(pathname: string) {
  const s = getStaticMeta(pathname);
  if (s) return { title: s.title, description: s.description };
  const m = pathname.match(/^\/products\/([^/]+)$/);
  if (m && PRODUCT_META_OVERRIDES[m[1]]) return PRODUCT_META_OVERRIDES[m[1]];
  return DEFAULT_META;
}
